<template>
  <div class="toast-box" v-if="toastMsg.length">
    <div class="toast">
      <p>
        <span v-for="(msg, index) in toastMsg" :key="'msg' + index"> {{ msg }} <br /></span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "toast",

  computed: {
    ...mapGetters(["toastMsg"])
  },

  methods: {},

  components: {}
}
</script>
